import { Circle as KonvaCircle } from "react-konva";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";

const Hotspot = ({ shapeProps, interaction }: BaseShapeProps<Hotspot>) => {

  const viewport = useAppSelector((state: RootState) => state.interface.viewport);

  const hotspotProps = {
    x: shapeProps.x,
    y: -shapeProps.y,
    id: shapeProps.id,
    radius: 4 / viewport.scale,
    fill: shapeProps.isDragging ? "lightblue" : "darkblue",
    //type: "circle",
    draggable: true,
    strokeWidth: 1 / viewport.scale,
    stroke: 'black'
  };

  return (
    <KonvaCircle
      {...hotspotProps}
      dragBoundFunc={function (this, pos) {
        return this._lastPos || this.absolutePosition();
      }}
      //position={{ x: 0, y: 0 }}
      onDragStart={interaction?.handleDragStart}
      onDragEnd={interaction?.handleDragEnd}
      onDragMove={interaction?.handleDragMove}
      onClick={() => {
        interaction?.handleClick?.(shapeProps);

      }
      }
    />
  )
}

export default Hotspot;